import React from 'react';
import PropTypes from 'prop-types';
import { t } from 'i18next';
import { Link } from '@sitecore-jss/sitecore-jss-react';
import NavigationGroup from './navigationGroup';
import {
  NavigationItem, Tooltip, SubNavigationItem, ChevronContainer, NavItemName,
} from './css';
import ChevronIcon from '../../assets/icons/chevron_icon.svg';

class NavigationSection extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpen: false,
    };
  }

  toggleNavItem = () => {
    this.setState((prevState) => ({
      isOpen: !prevState.isOpen,
    }));
  };

  openNavItem = () => {
    this.setState({ isOpen: true });
  };

  isActiveLink = (contextItemId, c) => c.link && c.link.targetItem && c.link.targetItem.id === contextItemId;

  isActive = (contextItemId, link, children) => {
    const sublinks = children.filter((c) => c.template.name === 'Navigation-Link');
    const activeSublinks = sublinks.filter((c) => this.isActiveLink(contextItemId, c));

    if (link.targetItem && link.targetItem.id && link.targetItem.id === contextItemId) {
      return true;
    }

    if (activeSublinks && activeSublinks.length > 0) {
      return true;
    }

    const groups = children.filter((c) => c.template.name === 'Navigation-Group');
    const activeGroupSublinks = groups.filter((c) => {
      const activeLinks = c.children.filter((l) => this.isActiveLink(contextItemId, l));
      return activeLinks && activeLinks.length > 0;
    });
    return activeGroupSublinks && activeGroupSublinks.length > 0;
  };

  render() {
    const { children, title, link } = this.props.section;
    const { contextItemId } = this.props;
    if (link.jss.value.href === '') {
      link.jss.value.href = '#';
    }

    return (
      <NavigationItem $isActive={this.isActive(contextItemId, link, children)} $isOpen={this.state.isOpen}>
        <NavItemName
          onClick={() => this.toggleNavItem()}
          tabIndex={0}
          onFocus={() => this.openNavItem()}
          onMouseDown={(e) => e.preventDefault()}
        >
          <Link field={link.jss}>{title.value}</Link>
          <ChevronContainer>
            <object type="image/svg+xml" data={ChevronIcon} aria-label={t('MoreOptions')} />
          </ChevronContainer>
        </NavItemName>
        <Tooltip>
          {
                        children.map((c) => {
                          if (c.template.name === 'Navigation-Group') {
                            return <NavigationGroup key={c.id} section={c} contextItemId={contextItemId} />;
                          }

                          if (c.template.name === 'Navigation-Link') {
                            return <SubNavigationItem key={c.id}><Link field={c.link.jss} to="#" /></SubNavigationItem>;
                          }

                          return null;
                        },
                        )
}
        </Tooltip>
      </NavigationItem>
    );
  }
}

NavigationSection.propTypes = {
  section: PropTypes.shape({
    title: PropTypes.object,
    link: PropTypes.shape({
      jss: PropTypes.object,
    }),
    children: PropTypes.array,
  }),
  contextItemId: PropTypes.string,
};

export default NavigationSection;
